export function buildPromoLink(message) {
    const dataPromo = JSON.stringify({
        promoStartDate: message.promoStartDate,
        promoEndDate: message.promoEndDate,
        promoCode: message.promoCode,
        promoDetailsType: message.promoDetailsType,
        promoDetailsRef: message.promoDetailsRef,
    });
    const escapedDataPromo = dataPromo.replace(/'/g, '&apos;');

    return ` <a class="jos-show-terms-and-conditions" style="display: none" role="button" tabindex="0" aria-haspopup="dialog" aria-expanded="false" data-promo='${escapedDataPromo}'>See details and exclusions</a>`;
}

export function appendLinkToDesc(desc, link) {
    const closingTagMatch = desc.match(/(<\/[a-z]+>\s*)$/i);

    if (closingTagMatch) {
        // Insert link before the last closing tag
        const insertAt = desc.lastIndexOf(closingTagMatch[0]);
        return desc.slice(0, insertAt) + link + desc.slice(insertAt);
    }

    return desc + link;
}